import { Component, Input, OnChanges, OnInit, ViewChild } from '@angular/core';
import { EMailValidation, ScApiService, ScuiModalComponent } from '@sc-ui';
import { UserService } from 'src/services/user.service';
import { LocalizationService } from 'src/services/localization.service';
import { texts } from './project-base-user-card.texts';

@Component({
  standalone: false,
  selector: 'app-project-base-user-card',
  templateUrl: './project-base-user-card.component.html',
  styleUrls: ['./project-base-user-card.component.scss']
})
export class ProjectBaseUserCardComponent implements OnInit, OnChanges {

  texts = texts;

  @Input()
  project: any;

  users: any = [];

  projectUsers: any = []

  q = "";

  showAddEMail = false;

  isAddingByEMail = false;

  isSearching = false;

  // why the last add failed, shown in the modal until the next search or add
  addError: any = null;

  @ViewChild('modal')
  userModal : ScuiModalComponent;

  @ViewChild('demoAccountModal')
  demoAccountModal : ScuiModalComponent;

  constructor(private api: ScApiService, private userService : UserService, public loc : LocalizationService) { }

  ngOnInit(): void {
  }

  ngOnChanges() {
    this.users = [];

    if (!this.project) return;

    this.api.get(`users`).subscribe(d => {
      this.users = d;
      this.updateUserStates();
    })

    this.api.get(`projects/${this.project.Id}/users`).subscribe(d => {
      this.projectUsers = d;
      this.updateUserStates();
    })
  }

  showAddUsersModal()
  {
    if (this.userService.me.IsDemo)
    {
      this.demoAccountModal.show();
      return;
    }

    this.userModal.show();
  }

  updateUserStates() {
    this.users.forEach(u => {
      u.isAdded = false;
      u.canAdd = true;

      var projectUser = this.projectUsers.find(u2 => u2.Id == u.Id);
      if (projectUser) {
        u.isAdded = true;
        u.canRemove = !projectUser.IsManager && !projectUser.IsDecider && !projectUser.IsSelf;
      }
    });

    this.projectUsers.forEach(u => {
      u.isAdded = true;
      u.canRemove = !u.IsManager && !u.IsDecider && !u.IsSelf;
    });
  }

  searchSoon() {
    this.showAddEMail = false;
    this.addError = null;

    if (this['searchTimeout']) clearTimeout(this['searchTimeout']);
    this['searchTimeout'] = setTimeout(() => {

      this.isSearching = true;

      this.api.get('users?q=' + encodeURIComponent(this.q)).subscribe((d: any) => {
        this.users = d;
        this.updateUserStates();
        // this.searchPending = false;    
        if (d?.length == 0)
        {
          this.validateEMail();
        }  
        this.isSearching = false;
      })
    }, 500);

  }

  validateEMail()
  {
    console.log('validating ail');
    this.showAddEMail = EMailValidation.validate(this.q);
  }

  // the card's own list, removing like sc-user-list does for the modal
  remove(user: any) {
    user.isRemoving = true;

    this.removeUser({
      user: user,
      confirm: () => user.isRemoving = false,
      error: () => user.isRemoving = false
    });
  }

  removeUser(args: any) {
    var user = args.user;

    this.api.delete('projects/' + this.project.Id + '/users/' + user.Id).subscribe(() => {
      var i = this.projectUsers.indexOf(user);
      this.projectUsers.splice(i, 1);
      args.confirm();
      this.updateUserStates();
    });
  }

  addUser(args: any) {
    var user = args.user;
    this.addError = null;

    this.api.post('projects/' + this.project.Id + '/users', user).subscribe({
      next: (d: any) => {
        user.isAdded = true;
        user.canRemove = true;
        this.projectUsers.push(user);
        args.confirm();
        this.updateUserStates();
      },
      error: (e: any) => {
        args.error();
        this.addError = this.addErrorText(e);
      }
    });
  }

  addByEMail()
  {
    this.isAddingByEMail = true;
    this.addError = null;

    var user : any = {
      EMail : this.q
    };

    this.api.post('projects/' + this.project.Id + '/users', user).subscribe({
      next: (u: any) => {
        u.isAdded = true;
        u.canRemove = true;
        this.projectUsers.push(u);
        this.users.push(u);
        this.showAddEMail = false;
        this.isAddingByEMail = false;
      },
      error: (e: any) => {
        this.isAddingByEMail = false;
        this.addError = this.addErrorText(e);
      }
    });
  }

  // PostUser answers OtherCompany when the account belongs to another organization
  private addErrorText(e: any) {
    return e?.error?.Error == 'OtherCompany' ? texts.userOfOtherCompany : texts.addUserFailed;
  }

}
